
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');

    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var Customizer = {};
Customizer.endpoint = window.location.href.indexOf("dev=true") == -1 ? 'https://name-bubbles.app/api/' : "https://dev.name-bubbles.app/api/";
// Customizer.endpoint = 'https://namebubbles.test/api/';
// Customizer.endpoint = 'https://bigbonedgirl.com/api/';
Customizer.token = '';
Customizer.uploadCode = '';

// Properties for custom image management.
Customizer.customImage = {
    initialized: false,
    url: '',
    filename: '',
    width: 600,
    height: 420,
    mappedWidth: 600,
    mappedHeight: 420,
    aspectRatio: 1,
    zoom: 1,
    scale: 1,
    dragging: false,
    resizing: false,
    offsetX: 0,
    offsetY: 0,
    rotation: 0,
    mask: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        radius: 0
    }
}

// Show preview images in the mini cart.
$('body').on('click', '.minicart__toggle', function() {
    Customizer.getCustomizedImages({
        location: 'minicart'
    });
});

Customizer.init = function(productId) {
    console.log('customizer initialized')

    var d = new Date();
    Customizer.uploadCode = d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
    Customizer.uploadCode += '-' + Math.floor(Math.random() * 100000);

    Customizer.loadOptions(productId);

    Customizer.options = {};
    Customizer.app = new Vue({
        el: '#customizer',
        delimiters: ['${', '}'],
        data: {
            customImage: {
                url: '',
                top: 0,
                left: 0,
                scale: 1,
                rotate: 0,
                leftpx: 0,
                toppx: 0,
                rotatex: 0,
                rotatey: 0,
                scaleTransformed: 1
            },
            productCode: '',
            config: {
                product: {},
                shapes: [],
                shoes: [],
                fonts: [],
                palettes: [],
                icons: [],
                styles: [],
                groups: [],
                texts: [],
                laminations: []
            },
            upsells: [],
            availableUpsells: [],
            cartItem: {},
            pack: {},
            subtotal: {
                items: 0,
                price: 0
            },
            variants: [],
            variant: false,
            groups: {
                style: { selected: { label: '', option: {} }, options: [] },
                icon: { selected: { label: '', option: {} }, options: [] },
                palette: { selected: { label: '', option: {} }, options: [] },
                font: { selected: { label: '', option: {} }, options: [] },
                shape: { selected: { label: '', option: {} }, options: [] },
                shoe: { selected: { label: '', option: {} }, options: [] },
            },
            chosen: {
                style: undefined,
                palette: undefined,
                icon: undefined,
                font: undefined,
                shape: undefined,
                shoe: undefined,
                lamination: undefined,
                text: '',
                textRemoved: false
            },
            always: {
                style: false,
                palette: false,
                icon: false,
                font: false,
                shape: false,
                shoe: false,
                image: false
            },
            images: [],
            recentImages: [],
            imageSource: '',
            facebookConnected: false,
            instagramConnected: false,
            nextImagesUrl: '',
            properties: {},
            svg: '',
            cartId: '',
            cartQuantity: 1,
            confirmed: false
        },
        methods: {

            // Whether or not the object with the given id is a member
            // of the group.
            isMember: function(id, group) {
                if(!group.label) return true;
                return group.option.members.indexOf(id) >= 0;
            },
            selectImage: function(event) {
                var img = event.target;
                Customizer.customImage.url = img.src;
                Customizer.customImage.width = img.naturalWidth;
                Customizer.customImage.height = img.naturalHeight;
                Customizer.initCustomImage();

                var recent = Cookies.get('recentImages');
                if(!recent) {
                    recent = [];
                }
                else {
                    recent = JSON.parse(recent);
                }

                console.log(recent);

                recent.push(img.src);
                recent = recent.filter((v, i, a) => a.indexOf(v) === i); 


                Customizer.app.recentImages = recent;


                Cookies.set('recentImages', JSON.stringify(recent));

                $('.zoom-slider').slider('value', 50);
                $('.rotate-slider').slider('value', 0);

                $('#custom-image-container div').css('background-image', 'url(' + img.src + ')');
                console.log('image');
                console.log($('.svg-container svg image'));
//                 $('.svg-container svg image').attr('xlink:href', img.src);
                $('.image-overlay').css('background-image', 'url(' + img.src + ')');
                Customizer.positionMask();
                Customizer.resetImage();
            },
            showMorePhotos: function() {
                console.log(this.imageSource);
                console.log(this.nextImagesUrl);

                if(this.imageSource == 'instagram') {
                    var token = 'IGQVJWRlcxRU9KaExZATnVyc1BBemo3ZAzUzQ0FMeFlXSUJnREMtbDU2RmlsUDBYWXR1T185VjkxdnY3MnN3cWdhMjN6dUxVN0RRWFpCcUFNRHpXek83dUNoamlkcGRFSHNLTU5GWklxUE45bHZAEc1A4bWhDUlQ4bjNNb1Nj';
                    $.get(this.nextImagesUrl, function(response) {
                        for(var i = 0; i < response.data.length; i++) {
                            var media = response.data[i];
                            if(media.media_type == 'IMAGE')
                                Customizer.app.images.push(media.media_url)
                        }

                        Customizer.app.nextImagesUrl = response.paging.next ? response.paging.next : '';
                    }).fail(function(response) {

                        // If the request failed then we probably need a new token.
                        if(response.status == 400) {

                        }
                    });
                }
                else if(this.imageSource == 'facebook') {
                    FB.api(
                        this.nextImagesUrl,
                        'GET',
                        {"fields":"height,width,images"},
                        function(response) {
                            console.log(response);
                
                            for(var i = 0; i < response.data.length; i++) {
                                var media = response.data[i];
                                Customizer.app.images.push(media.images[3].source);
                            }
                            
                            Customizer.app.nextImagesUrl = response.paging.next;
                        }
                    );
                }
            },
            trim: function(string) {
                if(string.length > 12)
                    return string.substr(0, 10) + '...';
                return string;
            }
        }
    });

    var recent = Cookies.get('recentImages');
    if(!recent) {
        recent = [];
    }
    else {
        recent = JSON.parse(recent);
    }

    Customizer.app.recentImages = recent;
                

    Customizer.bindEvents();

    // Initialize to the initial product variant.
    var $customizer = $('#customizer');
    Customizer.app.variant = {
        id: $customizer.attr('data-variant-id'),
        price: parseFloat($customizer.attr('data-variant-price')) / 100,
        labels: $customizer.attr('data-labels'),
    }

    // Load available variant shapes and info.
    $('.swatch-element').each(function() {

        var name = $(this).attr('data-value');
        var shape = '';
        var color = '';
        var labels = $(this).attr('data-shape-label-count');

        if($(this).hasClass('shape'))
            shape = name;

        if($(this).hasClass('color'))
            color = name;

        Customizer.app.variants.push({
            id: $(this).attr('data-variant-id'),
            name: $(this).attr('data-value'),
            shape: shape,
            color: color,
            labels: labels ? labels : Customizer.app.variant.labels,
            price: parseFloat($(this).attr('data-variant-price')) / 100
        });
    });
}

/**
 * Create the product code based on the customization selections.
 */
Customizer.calculateProductCode = function() {

    var chosen = Customizer.app.chosen;
    var config = Customizer.app.config;
    
    var category = 'ZZZ';
    if(config.product.is_pack)
        category = config.product.category.vdpcode;
    else if(chosen.shape)
        category = chosen.shape.category.vdpcode;

    var shape = chosen.shape && chosen.shape.vdpcode ? chosen.shape.vdpcode : 'ZZZ';
    var shoe = chosen.shoe && chosen.shoe.vdpcode ? chosen.shoe.vdpcode : 'Z';
    if(chosen.shape && chosen.shape.category.is_shoe) {
        shape = 'ZZZ';
        shoe = chosen.shape.vdpcode;
    }

    Customizer.app.productCode = 
        config.product.type.vdpcode +
        category +
        (chosen.style.vdpcode ? chosen.style.vdpcode : 'ZZZZZZZ') +
        (chosen.palette.vdpcode ? chosen.palette.vdpcode : 'ZZ') +
        (chosen.icon && chosen.icon.vdpcode ? chosen.icon.vdpcode : 'ZZZZ') +
        (chosen.font && chosen.font.vdpcode ? chosen.font.vdpcode : 'ZZ') +
        shape +
        shoe +
        (chosen.lamination && chosen.lamination.vdpcode ? chosen.lamination.vdpcode : 'ZZZZ');

    // Add a random suffix so the product can be uniquely identified in the cart.
    // The backend will need to remove the suffix before processing the
    // product code.
    Customizer.app.productCode += '-' + Math.floor(Math.random() * 100);

    // Set product code for upsells based on the configuration
    // of the initial product.
    for(var i in Customizer.app.upsells) {
        var upsell = Customizer.app.upsells[i];
        var parentCode = Customizer.app.productCode;
        var code = 'NUPS' + parentCode.substr(4);
        code = code.substr(0, 4) + upsell.vdpcode + code.substr(7);
        code = code.substr(0, 22) + 'ZZZZ' + code.substr(26);

        var laminationExceptions = ['ZSA', 'ZFU', 'ZAL', 'ZBO', 'IRO', 'ZRO', 'ZRW', 'ZSU', 'ZTH', 'ZSO', 'ISR', 'ZBB', 'ZMI', 'ZSQ', 'ISO', 'ZLS', 'ZLR'];

        // Special handling for certain product types.
        if(upsell.vdpcode == 'ZSA')
            code = code.substr(0,22) + parentCode.substr(22, 3) + code.substr(25);
        if(upsell.vdpcode == 'ZSO')
            code = code.substr(0,25) + parentCode.substr(25, 1) + code.substr(26);
        if(laminationExceptions.indexOf(upsell.vdpcode) >= 0)
            code = code.substr(0,26) + 'ZZZZ';
        
        Customizer.app.upsells[i].productCode = code;
    }
}

/**
 * Check if all required fields have been filled in.
 */
Customizer.checkComplete = function() {

    var missingRequired = false;
    $('.texts .field.visible input[type=text]').each(function() {
        if($(this).hasClass('required') && $(this).val().trim() == '')
            missingRequired = true;
    });

    var missingRequiredCheck = false;
//     $('.review-items input[type=checkbox]').each(function() {
//         if($(this).prop('checked') == false)
//             missingRequiredCheck = true;
//     });

//     Customizer.app.confirmed = !missingRequiredCheck;

    setTimeout(function() {

        if(missingRequired)
            $('.option[data-choices=texts]').removeClass('selected');
        else
            $('.option[data-choices=texts]').addClass('selected');

        $('.option[data-choices=texts] .selected-option').text($('.texts input.required').val());

        var missingSelection = false;
        $('#sections .option.visible').each(function() {
            if(!$(this).hasClass('selected')) {
                missingSelection = true;
            }
        })

        if(missingRequired || missingSelection || missingRequiredCheck) {
            $('#options .add-to-cart').attr('disabled', true);
        }
        else {
            $('#options .add-to-cart').removeAttr('disabled');
        }
    }, 1);
}

/** 
 * Load customization options from the API 
 */
Customizer.loadOptions = function(productId) {

    $.get(Customizer.endpoint + 'config?product=' + productId, function(response) {

        Customizer.options = response;
        Customizer.app.config.styles = Customizer.options.styles;
        Customizer.app.upsells = response.upsells;

        // Load fonts from google.
        for(var i = 0; i < Customizer.options.fonts.length; i++) {
            Customizer.loadFont(Customizer.options.fonts[i]);
        }

        // Load Lato as the default font.
        Customizer.loadFont({ handle: 'Lato' });

        // Choose a default style to begin.
        Customizer.app.chosen.style = Customizer.app.config.styles[0];

        Customizer.setConfig();
        Customizer.loadUpsells();

        // Delay with a small timeout to make sure vue data is loaded before
        // we try to manipulate it.
        setTimeout(function() {
            Customizer.setAlwaysOptions(response.positions);
            Customizer.sortOptions(response.positions);

            var itemId = getParameterByName('item');
            if(itemId) {

                $.get('/cart.js', function(response) {
                    for(var i in response.items) {
                        if(response.items[i].id == itemId) {
                            Customizer.app.cartItem = response.items[i];
                            Customizer.loadConfigFromUrl();
                            Customizer.render();
                            Customizer.renderThumbnails();

                            $('.customize').trigger('click');
                            $('.add-to-cart span').text('Update Cart');
                            $('#options .option.visible').first().trigger('click');
                            break;
                        }
                    }
                }, 'json');
            }
            else {
                // Show the first option to start.
                $('#options .option.visible').first().trigger('click');
            }

        }, 1);

        // Allow the user to start customizing.
        $('.button.customize').prop('disabled', false).find('.text').text('Start Customizing');
        
    }, 'json');
}

/**
 * Sort elements by the "sortby" property.
 */
Customizer.sortBy = function(a, b) {
    var posA = parseInt($(a).attr('sortby'));
    var posB = parseInt($(b).attr('sortby'));
    return (posA < posB) ? -1 : (posA > posB) ? 1 : 0;
}

/**
 * Set whether the options should be shown even with one value.
 */
Customizer.setAlwaysOptions = function(positions) {

    var always = Customizer.app.always;

    for(var i = 0; i < positions.length; i++) {

        var option = positions[i];

        if(option.name == 'Style' && option.show_always)
            always.style = true;

        if(option.name == 'Color' && option.show_always)
            always.palette = true;

        if(option.name == 'Icon' && option.show_always)
            always.icon = true;

        if(option.name == 'Font' && option.show_always)
            always.font = true;

        if(option.name == 'Shape' && option.show_always)
            always.shape = true;

        if(option.name == 'Shoe' && option.show_always)
            always.show = true;
    }
}

/**
 * Sort configuration options based on ordering from the api.
 */
Customizer.sortOptions = function(positions) {

    for(var i = 0; i < positions.length; i++) {
        var option = positions[i];

        // Apply the attribute we'll use later to
        // sort the lists.
        $('.option').each(function() {
            if($(this).data('option') == option.name) {
                $(this).attr('sortby', i);
            }
        });
        $('.choice-list').each(function() {
            if($(this).data('option') == option.name) {
                $(this).attr('sortby', i);
            }
        });
    }

    // Now actually sort the lists.
    $('.option').sort(Customizer.sortBy).appendTo('#sections');
    $('.choice-list').sort(Customizer.sortBy).appendTo('#choices');
}

/**
 * Set available configuration options based on the style.
 */
Customizer.setConfig = function() {

    var options = Customizer.options;
    var config = Customizer.app.config;
    var chosen = Customizer.app.chosen;

    var styleId = chosen.style.id;

    // Some options aren't dependent on the style.
    config.product = options.product;
    config.laminations = options.laminations;

    // First do shapes because some items might be dependent
    // (e.g. icons)
    config.shapes = chosen.style.shapes;
    Customizer.setDefaults();

    // Include items that are available for the current style.
    config.fonts = options.fonts.filter(font => font.styles.indexOf(styleId) >= 0);
    config.palettes = options.palettes.filter(palette => palette.styles.indexOf(styleId) >= 0);
    config.icons = options.icons.filter(icon => icon.styles.indexOf(styleId) >= 0);
    config.shoes = options.shoes.filter(shoe => shoe.styles.indexOf(styleId) >= 0);

    // Also filter icons based on the shape.
    if(!config.product.is_pack && chosen.shape) {
        config.icons = config.icons.filter(icon => icon.shapes.indexOf(chosen.shape.id) >= 0);
    }

    // Reset defaults in case some chosen options are no longer available.
    Customizer.setDefaults();

    // Filter the groups that should be displayed.
    Customizer.resetFilters();
    Customizer.filterGroups();

    // Filter upsells that should be displayed.
    Customizer.filterUpsells();

    // Valid texts pull from the shop for individual products and from the
    // style for packs.
    config.texts = config.product.is_pack ? 
        options.texts.filter(text => text.styles.indexOf(styleId) >= 0) :
        options.texts.filter(text => text.shapes.indexOf(chosen.shape.id) >= 0);

    // Check if the config change has changed the completion status.
    setTimeout(() => {
        Customizer.checkComplete();
        Customizer.calculateProductCode();
    }, 1);

    if(chosen.shape && chosen.shape.custom_image) {
        var svg = chosen.shape.custom_image.image;
        var start = svg.indexOf(' d="') + 4;
        var end = svg.indexOf('"', start);
        var path = svg.substr(start, end-start);
    }

    // if(Customizer.app.chosen.shape && Customizer.app.chosen.shape.custom_image && $('.choice-list.active').data('option') != 'Image') {
    //     $('#custom-image-container').show();
    // }
    // else {
    //     $('#custom-image-container').hide();
    // }
}

/**
 * Set the chosen options based on a previous design.
 */
Customizer.loadConfigFromUrl = function() {

    var options = Customizer.options;
    var config = Customizer.app.config;
    var chosen = Customizer.app.chosen;

    // Get the cart id if we editing a cart item.
    var parts = getParameterByName('key').split('=')
    Customizer.app.cartId = parts[0];
    Customizer.app.cartQuantity = parts[1].replace('-', '');

    var properties = Customizer.app.cartItem.properties;
    chosen.style = config.styles.filter(style => style.label == getParameterByName('Style'))[0];
    
    // Reset the config based on the style.
    Customizer.setConfig();

    // First we need to set the shape because there are dependencies on the
    // shape. Specifically the icon.
    var shapes = config.shapes.filter(shape => shape.label ==  getParameterByName('Shape'));
    if(shapes.length > 0) chosen.shape = shapes[0];

    // We need to set the config one more time now that we have a chosen shape.
    Customizer.setConfig();
    
    // Now update the chosen options.
    var palettes = config.palettes.filter(palette => palette.label == getParameterByName('Color'));
    var fonts = config.fonts.filter(font => font.label ==  getParameterByName('Font'));
    var icons = config.icons.filter(icon => icon.label ==  getParameterByName('Icon'));
    var shoes = config.shoes.filter(shoe => shoe.label ==  getParameterByName('Shoe'));
    var laminations = config.laminations.filter(lamination => lamination.label == getParameterByName('Lamination'));

    if(palettes.length > 0) chosen.palette = palettes[0];
    if(fonts.length > 0) chosen.font = fonts[0];
    if(icons.length > 0) chosen.icon = icons[0];
    if(shoes.length > 0) chosen.shoe = shoes[0];
    if(laminations.length > 0) chosen.lamination = laminations[0];

    // Filter the groups that should be displayed.
    Customizer.resetFilters();
    Customizer.filterGroups();

    // Update the text values.
    for(var i = 0; i < Customizer.app.config.texts.length; i++) {
        var text = Customizer.app.config.texts[i];
        var value = getParameterByName(text.label.replace(' ', ''));
        if(value) {
            Customizer.app.config.texts[i].value = value;
            if(text.handle == 'name')
                Customizer.app.chosen.text = value;
        }
    }

    // Load any upsells from the cart.
    if(getParameterByName('upsells')) {

        var upsellParams = getParameterByName('upsells').split('-');
        var cartUpsells = [];
        var upsellQuantities = [];
        for(var i = 0; i < upsellParams.length; i++) {
            var parts = upsellParams[i].split('=');
            cartUpsells.push(parts[0]);
            upsellQuantities.push(parts[1]);
        }

        var upsells = Customizer.app.upsells;
        for(var i = 0; i < cartUpsells.length; i++) {
            for(var j = 0; j < upsells.length; j++) {
                if(cartUpsells[i].indexOf(upsells[j].variantId) >= 0) {
                    upsells[j].addToCart = true;
                    upsells[j].cartId = cartUpsells[i];
                    upsells[j].cartQuantity = upsellQuantities[i];
                }
            }
        }
    }

    // Check if the config change has changed the completion status.
    setTimeout(() => {
        Customizer.checkComplete();
    }, 1);
}

/**
 * Reset filters to show all groups.
 */
Customizer.resetFilters = function() {

    var groups = Customizer.app.groups;
    groups.palette.selected.label = '';
    groups.icon.selected.label = '';
    groups.font.selected.label = '';
    groups.shape.selected.label = '';
    groups.shoe.selected.label = '';
}

/**
 * Set default values for each of the configuration options.
 */
Customizer.setDefaults = function() {

    var config = Customizer.app.config;
    var chosen = Customizer.app.chosen;

    chosen.palette = Customizer.getDefault(chosen.palette, config.palettes);
    chosen.font = Customizer.getDefault(chosen.font, config.fonts);
    chosen.shape = Customizer.getDefault(chosen.shape, config.shapes, true);
    chosen.shoe = Customizer.getDefault(chosen.shoe, config.shoes);
    chosen.lamination = Customizer.getDefault(chosen.lamination, config.laminations);
    chosen.icon = Customizer.getDefault(chosen.icon, config.icons);
}

/**
 * Get the default value for an option if the current selected value is
 * no longer valid.
 */
Customizer.getDefault = function(chosen, options, compareLabel) {
    
    // If an option isn't chosen, or it was chosen by default, or the chosen option
    // is not valid for the current style, then set a default.
    var option = chosen;
    var match = chosen && options.filter(option => option.id == chosen.id).length != 0;

    // If we're comparing by label then find the option that matches
    // the previous label and return that.
    if(compareLabel) 
    {
        match = chosen && options.filter(option => option.label == chosen.label).length != 0;
        if(match) {
            return options.filter(option => option.label == chosen.label)[0];
        }
    }

    if(!chosen || chosen.default || !match) {
        if(options.length > 0) {
            option = options[0];
            option.default = true;
        }
    }

    return options.length > 0 ? option : undefined;
}

/**
 * An upsell should only be displayed if the product has the
 * chosen style.
 */
Customizer.filterUpsells = function() {
    var styleId = Customizer.app.chosen.style.id;
    var upsells = Customizer.app.upsells;

    Customizer.app.availableUpsells = [];
    for(var i = 0; i < upsells.length; i++) {
        upsells[i].available = upsells[i].styles.indexOf(styleId) >= 0;

        if(upsells[i].available)
            Customizer.app.availableUpsells.push(upsells[i]);
    }
}

/**
 * Only include groups that have members available based on the
 * selected style.
 */
Customizer.filterGroups = function() {

    var groups = Customizer.app.groups;
    var config = Customizer.app.config;

    // Styles
    var styleIds = config.styles.map(style => { return style.id });
    groups.style.options = Customizer.options.groups.style.filter(
        group => styleIds.filter(id => group.members.includes(id)).length > 0
    );

    // Icons
    var iconIds = config.icons.map(icon => { return icon.id });
    groups.icon.options = Customizer.options.groups.icon.filter(
        group => iconIds.filter(id => group.members.includes(id)).length > 0
    );

    // Palettes
    var paletteIds = config.palettes.map(palette => { return palette.id });
    groups.palette.options = Customizer.options.groups.palette.filter(
        group => paletteIds.filter(id => group.members.includes(id)).length > 0
    );

    // Fonts
    var fontIds = config.fonts.map(font => { return font.id });
    groups.font.options = Customizer.options.groups.font.filter(
        group => fontIds.filter(id => group.members.includes(id)).length > 0
    );

    // Shapes
    var shapeIds = config.shapes.map(shape => { return shape.id });
    groups.shape.options = Customizer.options.groups.shape.filter(
        group => shapeIds.filter(id => group.members.includes(id)).length > 0
    );

    // Shoes
    var shoeIds = config.shoes.map(shoe => { return shoe.id });
    groups.shoe.options = Customizer.options.groups.shoe.filter(
        group => shoeIds.filter(id => group.members.includes(id)).length > 0
    );
}

/**
 * Choose an option value.
 */
Customizer.chooseOption = function(id, options) {
    var option = '';
    for(var i = 0; i < options.length; i++) {
        if(options[i].id == id) {
            var option = options[i];
            option.default = false;
            break;
            // return option;
        }
    }

    var chosen = Customizer.app.chosen;
    var url = window.location + '?';
    url += 'style=' + chosen.style.label;

    if(chosen.palette) url += '&color=' + chosen.palette.label;
    if(chosen.icon) url += '&icon=' + chosen.icon.label;
    if(chosen.font) url += '&font=' + chosen.font.label;
    if(chosen.shape) url += '&shape=' + chosen.shape.label;
    if(chosen.shoe) url += '&shoe=' + chosen.shoe.label;

    setTimeout(() => {
        Customizer.calculateProductCode();
    }, 1);

    return option;

    // if(config.product.has_lamination && chosen.lamination) 
    //     properties.Lamination = chosen.lamination.label;
}

/**
 * Load upsell variant data from the liquid generated data.
 */
Customizer.loadUpsells = function() {

    var upsells = Customizer.app.upsells;
    var $upsells = $('.upsells .upsell');
    
    $upsells.each(function() {
        var $upsell = $(this);
        for(var i = 0; i < upsells.length; i++) {
            var upsell = upsells[i];
            if(upsell.sku == $upsell.data('sku')) {
                upsells[i].type = $upsell.data('type');
                upsells[i].title = $upsell.data('title');
                upsells[i].quantity = $upsell.data('quantity');
                upsells[i].price = $upsell.data('price');
                upsells[i].compare_at = $upsell.data('compareat');
                upsells[i].variantId = $upsell.data('variant');
                upsells[i].image = $upsell.data('image');
                upsells[i].productCode = '';
                upsells[i].addToCart = false;
            }
        }
    });
}

/**
 * Download google fonts.
 */
Customizer.loadFont = function(font) {
    var s = document.createElement("link");
    s.href = "https://fonts.googleapis.com/css?family=" + font.handle
    s.rel = 'stylesheet';
    $("head").append(s);
}

/**
 * Render the current selections.
 */
Customizer.render = function(mw, mh, includeImage) {

    var texts = [];
    for(var i in Customizer.app.config.texts) {
        var t = Customizer.app.config.texts[i];
        texts.push({
            handle: t.handle,
            value: t.value ? t.value :  (t.removed ? '' : t.label)
        });
    }

    var maxWidth = $('.customizer-stage').width();
    var maxHeight = $('.customizer-stage').height();
    var chosen = Customizer.app.chosen;

    if(mw) maxWidth = mw;
    if(mh) maxHeight = mh;

    var customImage = '';
    if(includeImage) {
        customImage = Customizer.customImage.url + ';' +
            Customizer.app.customImage.leftpx + ';' +
            Customizer.app.customImage.toppx + ';' +
            Customizer.app.customImage.scaleTransformed + ';' +
            -1*Customizer.app.customImage.rotate + ';' +
            Customizer.app.customImage.left + ';' +
            Customizer.app.customImage.top + ';' +
            Customizer.app.customImage.scale + ';' +
            Customizer.app.customImage.rotate;
    }

    var params = {
        product: Customizer.options.product.id,
        style: chosen.style.id,
        shape: chosen.shape? chosen.shape.id : '',
        palette: chosen.palette ? chosen.palette.id : '',
        icon: chosen.icon ? chosen.icon.id : '',
        font: chosen.font ? chosen.font.id : '',
        shoe: chosen.shoe ? chosen.shoe.id : '',
        texts: texts,
        maxWidth: maxWidth > maxHeight ? maxHeight : maxWidth,
        image: customImage
    };

    $.get(Customizer.endpoint + 'render', params, function(response) {
        var svg = response.svg.replace('<?xml version="1.0" encoding="utf-8"?>', '');

        if(!mw) {
            $('.product-images__stage').hide();
            $('.customizer-stage .svg-container').html(svg);
            $('.customizer-stage').css('display', 'flex');

            Customizer.initCustomImage();
            Customizer.drawImage();
            
        }
        else {
            Customizer.app.svg = svg;
            // $('.customizer-stage').append($('.image-overlay').clone().show());
        }

    }, 'json');
}

Customizer.renderUpsell = function(upsell, callback) {

    var texts = [];
    for(var i in Customizer.app.config.texts) {
        var t = Customizer.app.config.texts[i];
        texts.push({
            handle: t.handle,
            value: t.value ? t.value : t.label
        });
    }

    var maxWidth = 125;
    var maxHeight = 125;
    var chosen = Customizer.app.chosen;

    var customImage = Customizer.customImage.url + ';' +
        Customizer.app.customImage.leftpx + ';' +
        Customizer.app.customImage.toppx + ';' +
        Customizer.app.customImage.scaleTransformed + ';' +
        -1*Customizer.app.customImage.rotate + ';' +
        Customizer.app.customImage.left + ';' +
        Customizer.app.customImage.top + ';' +
        Customizer.app.customImage.scale + ';' +
        Customizer.app.customImage.rotate;

    var params = {
        sku: upsell.sku,
        vdpcode: upsell.vdpcode,
        style: chosen.style.id,
        palette: chosen.palette ? chosen.palette.id : '',
        icon: chosen.icon ? chosen.icon.id : '',
        font: chosen.font ? chosen.font.id : '',
        shoe: chosen.shoe ? chosen.shoe.id : '',
        texts: texts,
        maxWidth: maxWidth > maxHeight ? maxHeight : maxWidth,
        image: customImage
    };

    $.get(Customizer.endpoint + 'render', params, function(response) {
        svg = response.svg.replace('<?xml version="1.0" encoding="utf-8"?>', '');
        upsell.svg = svg;
        callback(svg);
    }, 'json');
}

Customizer.bindEvents = function() {

    $('body').on('click', '.zoom-up', function() {
        var zoom = $('.zoom-slider').slider('value');
        zoom += 5;
        $('.zoom-slider').slider('value', zoom);
        Customizer.app.customImage.scale = (zoom - 50) / 100 + 1;
        Customizer.drawImage();
    });

    $('body').on('click', '.zoom-down', function() {
        var zoom = $('.zoom-slider').slider('value');
        zoom -= 5;
        $('.zoom-slider').slider('value', zoom);
        Customizer.app.customImage.scale = (zoom - 50) / 100 + 1;
        Customizer.drawImage();
    });

    $('body').on('click', '.rotate-up', function() {
        var rotate = $('.rotate-slider').slider('value');
        rotate += 5;
        $('.rotate-slider').slider('value', rotate);
        Customizer.app.customImage.rotate = rotate;
        Customizer.drawImage();
    });

    $('body').on('click', '.rotate-down', function() {
        var rotate = $('.rotate-slider').slider('value');
        rotate -= 5;
        $('.rotate-slider').slider('value', rotate);
        Customizer.app.customImage.rotate = rotate;
        Customizer.drawImage();
    });
    
    // Sliders for manipulating a custom image.
    $('.zoom-slider').slider({
        min: 1,
        max: 100,
        value: 50,

        slide: function( event, ui ) {

            var $elem = $('#image-overlay');
            var elem = $elem[0];

            var top = parseFloat(elem.style.top);
            var left = parseFloat(elem.style.left);
            var width = parseFloat(elem.style.width);
            var height = parseFloat(elem.style.height);
        
            Customizer.app.customImage.scale = (ui.value - 50) / 100 + 1;
            $elem.css('width', (Customizer.customImage.mappedWidth*Customizer.customImage.zoom) + 'px');
            elem.style.height = (Customizer.customImage.mappedWidth*Customizer.customImage.zoom / Customizer.customImage.aspectRatio) + 'px';
        
            var wd = width - parseFloat(elem.style.width);
            var hd = height - parseFloat(elem.style.height);
            elem.style.top = (parseFloat(elem.style.top) + hd/2) + 'px';
            elem.style.left = (parseFloat(elem.style.left) + wd/2) + 'px';

            Customizer.positionMask();
            Customizer.drawImage();
        }
    });

    // Sliders for manipulating a custom image.
    $('.rotate-slider').slider({
        min: -180,
        max: 180,
        value: 0,

        slide: function( event, ui ) {
            // return;
            Customizer.customImage.rotation = ui.value;
            Customizer.app.customImage.rotate = ui.value;
            $('#image-overlay').css('transform', 'rotate(' + ui.value + 'deg)');
            $('#custom-image-container').css('transform', 'rotate(' + ui.value + 'deg)');
            // $('.svg-container svg image').attr('transform', 'rotate(' + ui.value + ', 49, 49)');
            Customizer.drawImage();
            // Customizer.positionMask();
        }
    });

    $('body').on('click', '.reset-image', function() {
        Customizer.resetImage();
        $('.zoom-slider').slider('value', 50);
        $('.rotate-slider').slider('value', 0);
    });

    // Events to handle custom images.
    $('body').on('mousemove', Customizer.move);
    $('body').on('mousedown',  Customizer.mouseDown);
    $('body').on('mouseup', Customizer.mouseUp);
    // window.addEventListener('mousedown', Customizer.mouseDown, false);
    // window.addEventListener('mouseup', Customizer.mouseUp, false);

    // Move image handlers.
    $('body').on('click', '.move-inputs .fa-arrow-up', function() {
        var rad = Customizer.app.customImage.rotate * Math.PI / 180;
        var x = Customizer.app.customImage.left;
        var y = Customizer.app.customImage.top;

      
        sign = -1;
        if(Math.abs(Customizer.app.customImage.rotate) > 90)
            sign = 1;

        var yd = Math.abs(((90 - Math.abs(Customizer.app.customImage.rotate)) / 90));
        var xd = 1 - yd;
        yd *= sign;
        if(Math.abs(Customizer.app.customImage.rotate) > 90)
            xd *= -1;


      
        // Customizer.app.customImage.top += yd;
        // Customizer.app.customImage.left += xd;

        Customizer.app.customImage.top--;

        Customizer.drawImage();
    });
    $('body').on('click', '.move-inputs .fa-arrow-down', function() {
        Customizer.app.customImage.top++;

        Customizer.drawImage();
    });
    $('body').on('click', '.move-inputs .fa-arrow-left', function() {
    
        var rad = Customizer.app.customImage.rotate * Math.PI / 180;
        var x = Customizer.app.customImage.left;
        var y = Customizer.app.customImage.top;

        sign = -1;
        if(Math.abs(Customizer.app.customImage.rotate) > 90)
            sign *= -1;

        var xd = Math.abs(((90 - Math.abs(Customizer.app.customImage.rotate)) / 90));
        var yd = 1 - xd;
        xd *= sign;
        if(Customizer.app.customImage.rotate < 0)
            yd *= -1;


        Customizer.app.customImage.left--;
        // Customizer.app.customImage.top += yd;

        Customizer.drawImage();

    });
    $('body').on('click', '.move-inputs .fa-arrow-right', function() {
        var rad = Customizer.app.customImage.rotate * Math.PI / 180;
        var x = Customizer.app.customImage.left;
        var y = Customizer.app.customImage.top;

        sign = -1;
        if(Math.abs(Customizer.app.customImage.rotate) > 90)
            sign *= -1;

        var xd = Math.abs(((90 - Math.abs(Customizer.app.customImage.rotate)) / 90));
        var yd = 1 - xd;
        xd *= sign;
        if(Customizer.app.customImage.rotate < 0)
            yd *= -1;

        // Customizer.app.customImage.left += -1*xd;
        // Customizer.app.customImage.top += -1*yd;
        
        Customizer.app.customImage.left++;

        Customizer.drawImage();
    });

    $('.add-to-cart').on('click', function(e) {
        
        e.preventDefault();
        e.stopPropagation();
        $(this).prop('disabled', true);
        Customizer.addToCart();

        return false;
    });

    $('.customize').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Don't show gallery options for cutomizable products.
        $('[data-feat-prod-slick]').hide();
        $('.product-images__stage').show();

        // If a config isn't being loaded from the URL then
        // try to load from choices on the PDP.
        if(!getParameterByName('item'))
            Customizer.loadConfigFromVariant();

        // Also set the underlying variant to match.
        Customizer.setVariant();

        if(Customizer.app.config.styles.length > 0) {
            Customizer.setConfig();
        }

        $('.product-desc-test').hide();
        $('.product-desc').hide();
        
        // $('.product-images__container').addClass('customize').append($('#preview'));
        $('.product-images__container').next('.column').addClass('customize-options').prepend($('#options'));
        $('.product-images__container').next('.column').addClass('customize-options').prepend($('#confirmation'));
        $('#preview').show();
        $('#options').show();
        $('body').addClass('show-customizer');
        Customizer.render();
    });

    $('.upsell-products').on('click', 'button', function () {

        if(!$(this).hasClass('added')) {
            
            var $variant = $(this).closest('.upsell-product');
            var variantId = $variant.attr('variant');

            var upsell = Customizer.findUpsell(variantId);
            upsell.addToCart = true;
            Customizer.app.$forceUpdate();
            $(this).blur();
        }
        else {

                        
            var $variant = $(this).closest('.upsell-product');
            var variantId = $variant.attr('variant');

            var upsell = Customizer.findUpsell(variantId);
            upsell.addToCart = false;
            Customizer.app.$forceUpdate();
            $(this).blur();
        }
    });

    $('#close-customizer').on('click', function() {
        $('#customizer').hide();
        $('#preview').hide();
        $('#options').hide();
        $('body').css('overflow', 'auto');
    });

    $('body').on('click', '.option.selectable', function() {

        $('#sections').hide();
        $('.title-content').text($(this).data('title'));
        $('.choice-list.active').removeClass('active');
        $('.filter.active').removeClass('active');
        $('.choice-list.' + $(this).data('choices')).addClass('active');
        $('.filter.' + $(this).data('choices')).addClass('active');
        $('#choices').fadeIn();

        $('.next').removeAttr('disabled').show();
        $('.next.mobile').removeClass('disabled');
        $('.review').addClass('disabled');
        $('.add-to-cart.last-step').hide();
        $('.choice-list.last-step').removeClass('last-step');
        if($('.choice-list.active').nextAll('.choice-list.available').length == 0) {
            Customizer.showReviewStep();
        }

        $('.back').removeAttr('disabled');
        if($('.choice-list.active').prevAll('.choice-list.available').length == 0) {
            $('.back').attr('disabled', true);
        }

        $('.item-count .index').text($('.choice-list.available').index($('.choice-list.active')) + 1);
        $('.item-count .total').text($('.choice-list.available').length);
        $('.missing-text').hide();
    });

    $('.close-choices, .review').on('click', function() {
        $('#choices').hide();
        $('#sections').fadeIn();
    });

    $('.choice-list').on('click', '.style', function() {
        Customizer.app.chosen.style = Customizer.chooseOption(
            $(this).attr('styleid'), 
            Customizer.app.config.styles
        );

        // Config depends on style.
        Customizer.setConfig();

        Customizer.render();
    });

    $('.choice-list').on('click', '.icon', function() {
        Customizer.app.chosen.icon = Customizer.chooseOption(
            $(this).attr('iconid'), 
            Customizer.app.config.icons
        );

        // If there is a matching shape and the chosen shape
        // is still the default then update the shape to match
        // the icon.
        var config = Customizer.app.config;
        var chosen = Customizer.app.chosen;
        if(!chosen.shape || chosen.shape.default) {
            for(var i = 0; i < config.shapes.length; i++) {
                if(config.shapes[i].label == chosen.icon.label) {
                    chosen.shape = config.shapes[i];
                    chosen.shape.default = true;
                    break;
                }
            }
        }

        Customizer.render();
    });

    $('.choice-list').on('click', '.palette', function() {
        Customizer.app.chosen.palette = Customizer.chooseOption(
            $(this).attr('paletteid'), 
            Customizer.app.config.palettes
        );

        Customizer.render();
    });

    $('.choice-list').on('click', '.font', function() {
        Customizer.app.chosen.font = Customizer.chooseOption(
            $(this).attr('fontid'), 
            Customizer.app.config.fonts
        );

        Customizer.render();
    });

    $('.choice-list').on('click', '.shape', function() {
        Customizer.app.chosen.shape = Customizer.chooseOption(
            $(this).attr('shapeid'), 
            Customizer.app.config.shapes
        );

        // Find the variant that matches the shape.
        Customizer.setVariant();

        // Config can depend on shape.
        Customizer.setConfig();

        Customizer.initCustomImage();
        // Customizer.drawImage();
        // Customizer.resetImage();

        Customizer.render();
    });

    $('.choice-list').on('click', '.lamination', function() {
        Customizer.app.chosen.lamination = Customizer.chooseOption(
            $(this).attr('laminationid'), 
            Customizer.app.config.laminations
        );
    });

    $('.choice-list').on('click', '.shoe', function() {
        Customizer.app.chosen.shoe = Customizer.chooseOption(
            $(this).attr('shoeid'), 
            Customizer.app.config.shoes
        );

        Customizer.render();
    });

    $('#choices').on('change', '.filter.styles select', function() {
        Customizer.app.groups.style.selected.option = {};
        for(var i = 0; i < Customizer.app.groups.style.options.length; i++) {
            var option = Customizer.app.groups.style.options[i];
            if(option.label == Customizer.app.groups.style.selected.label)
                Customizer.app.groups.style.selected.option = option;
        }
    });

    $('#choices').on('change', '.filter.icons select', function() {
        Customizer.app.groups.icon.selected.option = {};
        for(var i = 0; i < Customizer.app.groups.icon.options.length; i++) {
            var option = Customizer.app.groups.icon.options[i];
            if(option.label == Customizer.app.groups.icon.selected.label)
                Customizer.app.groups.icon.selected.option = option;
        }
    });

    $('#choices').on('change', '.filter.palettes select', function() {
        Customizer.app.groups.palette.selected.option = {};
        for(var i = 0; i < Customizer.app.groups.palette.options.length; i++) {
            var option = Customizer.app.groups.palette.options[i];
            if(option.label == Customizer.app.groups.palette.selected.label)
                Customizer.app.groups.palette.selected.option = option;
        }
    });

    $('#choices').on('change', '.filter.fonts select', function() {
        Customizer.app.groups.font.selected.option = {};
        for(var i = 0; i < Customizer.app.groups.font.options.length; i++) {
            var option = Customizer.app.groups.font.options[i];
            if(option.label == Customizer.app.groups.font.selected.label)
                Customizer.app.groups.font.selected.option = option;
        }
    });

    $('#choices').on('change', '.filter.shapes select', function() {
        Customizer.app.groups.shape.selected.option = {};
        for(var i = 0; i < Customizer.app.groups.shape.options.length; i++) {
            var option = Customizer.app.groups.shape.options[i];
            if(option.label == Customizer.app.groups.shape.selected.label)
                Customizer.app.groups.shape.selected.option = option;
        }
    });

    $('#choices').on('change', '.filter.shoes select', function() {
        Customizer.app.groups.shoe.selected.option = {};
        for(var i = 0; i < Customizer.app.groups.shoe.options.length; i++) {
            var option = Customizer.app.groups.shoe.options[i];
            if(option.label == Customizer.app.groups.shoe.selected.label)
                Customizer.app.groups.shoe.selected.option = option;
        }
    });

    $('body').on('click', '.review-items input[type=checkbox]', function() {

        setTimeout(() => {
            Customizer.checkComplete();
        }, 1);
    });

    $('body').on('click', '.remove-required', function() {

        var $cb = $(this).find('input');
        var $text = $(this).siblings('input[type=text]');
        var removed = false;
        if($cb.prop('checked')) {
            $text.removeClass('required');
            $text.addClass('removed');
            Customizer.app.chosen.text = '';
            removed = true;
        }
        else {
            $text.addClass('required');
            $text.removeClass('removed');
        }

        var texts = Customizer.app.config.texts;
        for(var i = 0; i < texts.length; i++) {

            if($text.attr('name') == texts[i].handle) {
                
                texts[i].removed = removed;
                if(removed) {
                    texts[i].value = '';
                    Customizer.app.$forceUpdate();
                }
            }
        }

        Customizer.app.chosen.textRemoved = removed;
        
        Customizer.render();
    });

    $('.texts').on('keyup', 'input', function() {

        var texts = Customizer.app.config.texts;

        for(var i = 0; i <texts.length; i++) {

            if($(this).attr('name') == texts[i].handle) {
                if(texts[i].handle == 'name')
                    Customizer.app.chosen.text = $(this).val();
                    
                texts[i].value = $(this).val();

                $('.char-count').css('opacity', 0);
                var len = texts[i].value.length;
                $(this).siblings('.char-count').text(len + '/' + $(this).attr('maxlength')).css('opacity', 1);

                if(len > 0) {
                    texts[i].removed = false;
                    $(this).siblings('.remove-required').find('input[type=checkbox]').prop('checked', false);
                }
            }
        }

        Customizer.checkComplete();
    });

    $('.texts').on('blur', 'input', function() {
        Customizer.render();
    });

    $('.texts').on('keyup', 'input', function() {
        Customizer.processTextUpdate();
    });


    $('#options').on('click', '.next', function() {

        var missingRequired = false;
        $('.missing').removeClass('missing');
        $('.missing-text').hide();
        if($('.choice-list.active').data('option') == 'Text') {
            $('.choice-list.active input').each(function() {
                if($(this).hasClass('required') && $(this).val().trim() == '') {
                    missingRequired = true;
                    $(this).addClass('missing');
                }
            });
        }

        if(missingRequired) {
            $('.missing-text').show();
            return;
        }

        var $active = $('.choice-list.active');
        $active.removeClass('active');
        $active.nextAll('.choice-list.available').first().addClass('active');
        $('.title-content').text($('.choice-list.active').data('title'));
        $('.filter.active').removeClass('active');
        $('.filter.' + $('.choice-list.active').data('choice')).addClass('active');

        $('#custom-image-container').show();
        if($('.choice-list.active').data('option') == 'Image') {
            // $('#custom-image-container').hide();
            // $('.image-overlay').show();
            // Customizer.positionMask();
            
        }
        else {
            // $('.image-overlay').hide();
            // if(Customizer.app.chosen.shape.custom_image)
            //     $('#custom-image-container').show();
            
        }
        
        $('.next').removeAttr('disabled').show();
        $('.review').addClass('disabled');
        $('.next.mobile').removeClass('disabled');
        $('.add-to-cart.last-step').hide();
        $('.choice-list.last-step').removeClass('last-step');
        $('.add-to-cart.mobile').removeClass('visible');
        if($('.choice-list.active').nextAll('.choice-list.available').length == 0) {
            Customizer.showReviewStep();
        }
        
        Customizer.checkComplete();

        $('.back').removeAttr('disabled');

        $('.item-count .index').text($('.choice-list.available').index($('.choice-list.active')) + 1);
        $('.item-count .total').text($('.choice-list.available').length);

    });

    $('#options').on('click', '.back', function() {

        $('.missing-text').hide();
        var $active = $('.choice-list.active');
        $active.removeClass('active');
        $active.prevAll('.choice-list.available').first().addClass('active');
        $('.title-content').text($('.choice-list.active').data('title'));

        $('.filter.active').removeClass('active');
        $('.filter.' + $('.choice-list.active').data('choice')).addClass('active');

        if($('.choice-list.active').prevAll('.choice-list.available').length == 0) {
            $('.back').attr('disabled', true);
        }

        $('#custom-image-container').show();
        if($('.choice-list.active').data('option') == 'Image') {
            // $('#custom-image-container').hide();
            // $('.image-overlay').show();
            // Customizer.positionMask();
        }
        else {

            // $('.image-overlay').hide();
            // if(Customizer.app.chosen.shape.custom_image)
            //     $('#custom-image-container').show();
            
        }

        $('.next.mobile').removeClass('disabled');
        $('.next').removeAttr('disabled').show();
        $('.review').addClass('disabled');
        $('.add-to-cart.last-step').hide();
        $('.choice-list.last-step').removeClass('last-step');
        $('.add-to-cart.mobile').removeClass('visible');
        if($('.choice-list.active').nextAll('.choice-list.available').length == 0) {
           Customizer.showReviewStep();
        }

        Customizer.checkComplete();

        $('.item-count .index').text($('.choice-list.available').index($('.choice-list.active')) + 1);
        $('.item-count .total').text($('.choice-list.available').length);
    });

    $('body').on('click', '.more-info', function() {
        $('.long').show();
        $('.less-info').show();
        $('.more-info').hide();
    });

    $('body').on('click', '.less-info', function() {
        $('.long').hide();
        $('.more-info').show();
        $('.less-info').hide();
    });

    // Handle a custom image upload.
    $('body').on('click', '.image-upload-trigger', function() {
        $('#image-upload').trigger('click');
    });

    $('body').on('change', '#image-upload', function() {

        var fileInput = document.getElementById('image-upload');
        var file = fileInput.files[0];
        var formData = new FormData();
        formData.append('image', file);
        formData.append('code',  Customizer.uploadCode);


        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('loadstart', onloadstartHandler, false);
        xhr.upload.addEventListener('progress', onprogressHandler, false);
        xhr.upload.addEventListener('load', onloadHandler, false);
        xhr.addEventListener('readystatechange', onreadystatechangeHandler, false);
        xhr.open('POST', Customizer.endpoint + 'images', true);

        xhr.send(formData);
    });
}


// Handle the start of the transmission
function onloadstartHandler(evt) {
    $('#upload-status').html('');
    $('#progress').html('');
    $('#upload-error').html('');
    $('.upload-status').show();
    var div = document.getElementById('upload-status');
    // div.innerHTML = 'Upload started.';
  }
  
  // Handle the end of the transmission
  function onloadHandler(evt) {
    var div = document.getElementById('upload-status');
    // div.innerHTML += '<' + 'br>File uploaded. Waiting for response.';
  }
  
  // Handle the progress
  function onprogressHandler(evt) {
    var div = document.getElementById('progress');
    var percent = evt.loaded/evt.total*100;
    div.innerHTML = 'Progress: ' + Math.floor(percent) + '%';
  }
  
  // Handle the response from the server
  function onreadystatechangeHandler(evt) {
    var status, text, readyState;
  
    try {
      readyState = evt.target.readyState;
      text = evt.target.responseText;
      status = evt.target.status;
    }
    catch(e) {
      $('#upload-error').html('There was an error uploading the image');
      return;
    }
  
    if (readyState == 4 && status == '200' && evt.target.responseText) {
      
      var obj = JSON.parse(evt.target.response);
      if(obj.error) {
        $('#upload-error').html(obj.error);
      }
      else {
        $('.upload-status').hide();
        Customizer.customImage.url = obj.url;
        Customizer.customImage.filename = obj.filename;
        Customizer.customImage.width = obj.width;
        Customizer.customImage.height = obj.height;
        Customizer.initCustomImage();
      }
    }
    else {
        $('#upload-error').html('There was an error uploading the image');
    }
  }


Customizer.resetImage = function() {
    Customizer.app.customImage.left = 0;
    Customizer.app.customImage.top = 0;
    Customizer.app.customImage.scale = 1;
    Customizer.app.customImage.rotate = 0;
    Customizer.drawImage();
}

Customizer.drawImage = function() {
	return;
    var ci = Customizer.app.customImage;

    var $svg = $('.svg-container svg image').closest('svg');
    var bBox = $svg[0].getBBox();
    
    var transform = '' +
        // 'matrix(' + ci.scale + ', 0, 0, ' + ci.scale + ', ' + (x-ci.scale*x) + ', ' + (y-ci.scale*y) + ') ' +
        'translate(' + ci.left + ',' + ci.top + ') ' +
        'scale(' + ci.scale + ') ' +
        'rotate(' + ci.rotate + ', 49, 49) ';

    var svgWidth = $('.svg-container > svg').width();
    var svgHeight = $('.svg-container > svg').height();
    var factor = 500 / svgWidth;
    Customizer.app.customImage.leftpx = (svgWidth*( bBox.x)/100*factor);
    Customizer.app.customImage.toppx = (svgHeight*( bBox.y)/100*factor);

    Customizer.app.customImage.scaleTransformed = svgWidth / Customizer.customImage.width * factor;
    Customizer.app.customImage.scaleTransformed *= Customizer.app.customImage.scale;

    $('.svg-container svg image').attr('transform', transform);
}

Customizer.showReviewStep = function() {

    $('.next').hide();
    $('.next.mobile').addClass('disabled');
    $('.review').removeClass('disabled');
    $('.add-to-cart.last-step').show();
    $('.choice-list.active').addClass('last-step');
    $('.add-to-cart.mobile').addClass('visible');

    Customizer.renderThumbnails();
}

Customizer.renderThumbnails = function() {

    if(Customizer.app.upsells.length > 0) {
        for(var i in Customizer.app.upsells) {
            var upsell = Customizer.app.upsells[i];
            Customizer.renderUpsell(upsell, function(svg) {
                Customizer.app.$forceUpdate();
            });
        }
    }

    Customizer.render(125, 125, true);
}


/**
 * Find an upsell for the variant.
 */
Customizer.findUpsell = function(variantId) {

    for(var i = 0; i < Customizer.app.upsells.length; i++) {
        if(Customizer.app.upsells[i].variantId == variantId)
            return Customizer.app.upsells[i];
    }
}

/**
 * If text is updated quickly then ignore grouped events to
 * improve performance.
 */
Customizer.processTextUpdate = function() {

    if(Customizer.timer) 
        clearTimeout(Customizer.timer);

    Customizer.timer = setTimeout(function() {
        Customizer.render();
    }, 500);
}

/**
 * Try to load a configurator config from the options
 * selected on the PDP.
 */
Customizer.loadConfigFromVariant = function() {

    // Try to find a shape that matches the selected option.
    var shape = $('.swatch__shape:checked').val();
    if(shape) {
        for(var i in Customizer.app.config.shapes) {
            if(Customizer.app.config.shapes[i].label == shape) {
                Customizer.app.chosen.shape = Customizer.chooseOption(
                    Customizer.app.config.shapes[i].id, 
                    Customizer.app.config.shapes
                );
                break;
            }
        }
    }

    // Try to find a palette that matches the selected option.
    var color = $('.swatch__color:checked').val();
    if(color) {
        for(var i in Customizer.app.config.palettes) {
            if(color.indexOf(Customizer.app.config.palettes[i].label) >= 0) {
                Customizer.app.chosen.palette = Customizer.chooseOption(
                    Customizer.app.config.palettes[i].id, 
                    Customizer.app.config.palettes
                );
                break;
            }
        }
    }
}

/**
 * Set the appropriate variant for the selected customization options.
 */
Customizer.setVariant = function() {

    var name = '';
    if(Customizer.app.chosen.shape)
        name = Customizer.app.chosen.shape.label;

    // Find the matching variant for this shape
    var shapeVariant = false;
    var colorVariant = false;
    for(var i in Customizer.app.variants) {
        if(Customizer.app.variants[i].shape == name) {
            shapeVariant = Customizer.app.variants[i];
        }
    }

    // If there isn't a matching shape the try to match custom by default.
    if(!shapeVariant) {
        for(var i in Customizer.app.variants) {
            if(Customizer.app.variants[i].shape == 'Custom') {
                shapeVariant = Customizer.app.variants[i];
            }
        }
    }

    // If there isn't a matching shape the try to match circle by default.
    if(!shapeVariant) {
        for(var i in Customizer.app.variants) {
            if(Customizer.app.variants[i].shape == 'Circle') {
                shapeVariant = Customizer.app.variants[i];
            }
        }
    }

    // If we still haven't found one then check against color variants.
    if(Customizer.app.chosen.palette) {
        name = Customizer.app.chosen.palette.label;
        for(var i in Customizer.app.variants) {
            if(Customizer.app.variants[i].color == name) {
                colorVariant = Customizer.app.variants[i];
            }
        }
    }

    var variant = shapeVariant ? shapeVariant : colorVariant;

    // If there are both types of variants then we need to find a 
    // variant that matches both.
    if(shapeVariant && colorVariant) {
        for(var i in Customizer.app.variants) {
            if(Customizer.app.variants[i].color == colorVariant.name &&
               Customizer.app.variants[i].shape == shapeVariant.name) {
                variant = Customizer.app.variants[i];
            }
        }
    }

    if(variant) {
        Customizer.app.variant = variant;
    }
}

Customizer.addUpsellsToCart = function(upsells, i) {

    if(i >= upsells.length) return;

    var upsell = upsells[i];
    if(!upsell.available) return;

    var upsellProperties = Customizer.app.properties;
    upsellProperties._parent = Customizer.app.productCode;
    upsellProperties._ProductCode = upsell.productCode;
    upsellProperties.Labels = upsell.quantity;
    delete upsellProperties.Product;

    var params = { 
        quantity: upsell.cartQuantity, 
        id: upsell.variantId,
        properties: upsellProperties 
    };

    $.post('/cart/add.js', params, function(response) {
        Customizer.addUpsellsToCart(upsells, i+1);
    }, 'json');
}

Customizer.deleteItemsFromCart = function(items, i, callback) {

    if(i >= items.length)  {
        callback();
        return;
    }

    var item = items[i];
    $.post('/cart/change.js', { quantity: 0, id: item }, function(response) {
        Customizer.deleteItemsFromCart(items, i+1, callback);
    }, 'json');
}

/** 
 * Add the customized product to the cart with the appropriate information
 * for the VDP report.
 */
Customizer.addToCart = function() {
    // If this is custom image label then save the
    // svg so we can sanity check later.
    if(Customizer.customImage.url) {

        var params = {
            code: Customizer.uploadCode,
            svg: $('.svg-container').html()
        };

        $.post(Customizer.endpoint + 'svg', params);
    }

    var config = Customizer.app.config;
    var chosen = Customizer.app.chosen;

    var properties = {};
    properties.Product = config.product.name;
	
  	if(Customizer.app.variant.labels)
        properties.Labels = Customizer.app.variant.labels.replace('Labels', '').trim();

    for(var i = 0; i < config.texts.length; i++) {
        var text = config.texts[i];
        properties[text.label] = text.value;
    }

    if(Customizer.app.productCode)
        properties._ProductCode = Customizer.app.productCode;

    if(chosen.style)
        properties.Style = chosen.style.label;

    if(chosen.palette) 
        properties.Color = chosen.palette.label; 

    if(chosen.icon)
        properties.Icon = chosen.icon.label;
    
    if(chosen.font)
        properties.Font = chosen.font.label;

    if(chosen.shape) 
        properties.Shape = chosen.shape.label;

    if(chosen.shoe) 
        properties.Shoe = chosen.shoe.label;

    if(config.product.has_lamination && chosen.lamination) 
        properties.Lamination = chosen.lamination.label;

    if(Customizer.customImage.url) {
        properties._customimage = 
            Customizer.customImage.filename + ';' +
            Customizer.app.customImage.leftpx + ';' +
            Customizer.app.customImage.toppx + ';' +
            Customizer.app.customImage.scaleTransformed + ';' +
            -1*Customizer.app.customImage.rotate + ';' +
            Customizer.app.customImage.left + ';' +
            Customizer.app.customImage.top + ';' +
            Customizer.app.customImage.scale + ';' +
            Customizer.app.customImage.rotate;
    }

    // Track information so it can be used for updates based in
    // any upsell purchases.
    Customizer.app.properties = properties;
    Customizer.app.subtotal.items = 1;
    Customizer.app.subtotal.price = Customizer.app.variant.price;

    // Add upsell to subtotals information.

    var upsellsToAdd = [];
    for(var i = 0; i < Customizer.app.availableUpsells.length; i++) {
        var upsell = Customizer.app.availableUpsells[i];

        if(upsell.addToCart) {

            Customizer.app.subtotal.items++;
            Customizer.app.subtotal.price += parseFloat(upsell.price.replace('$', ''));
            upsellsToAdd.push(upsell);
        }
    }

    var params = { 
        quantity: Customizer.app.cartQuantity, 
        id: Customizer.app.variant.id, 
        properties: properties 
    };

    // Delete pre-existing cart items if this is a change
    // to an item that was already added to cart.

    var deletes = [];
    if(Customizer.app.cartId)
        deletes.push(Customizer.app.cartId);

    var upsells = Customizer.app.upsells;
    for(var i = 0; i < upsells.length; i++) {
        if(upsells[i].cartId)
            deletes.push(upsells[i].cartId);
    }
    
    Customizer.deleteItemsFromCart(deletes, 0, function() {
        const sellingPlan = document.querySelector('[name="selling_plan"]')
        if(sellingPlan && sellingPlan.value){
          params.selling_plan = sellingPlan.value
        }

        $.post('/cart/add.js', params, function(response) {
            $('#choices').hide();
            $('#confirmation').fadeIn();
            $("html, body").animate({
                scrollTop: 0
            }, 600);

            Customizer.addUpsellsToCart(upsellsToAdd, 0);
        }, 'json');
    });
}

/** 
 * Get images for for customized products in the cart.
 */
Customizer.getCustomizedImages = function(params) {

    var maxWidth = 110;
    var selector = '[data-line-item][data-product-code]:not([data-product-code=""])';

    if(params.location == 'minicart') {
        maxWidth = 90;
        selector = '.minicart__item[data-product-code]:not([data-product-code=""])';
    }

    $(selector).each(function() {
        var $product = $(this);
        var code = $product.attr('data-product-code');
        var parentCode = $product.attr('data-parent-code');
        var productId = $product.attr('data-design-id');
        var sku = $product.attr('data-sku');
        var customImage = $product.attr('data-custom-image');

        var properties = [];
        $product.find('.item-property').each(function() {
            properties.push({
            name: $(this).attr('data-field'),
            value: $(this).attr('data-value')
            });
        });

        var params = {
            product: parentCode ? '' : productId,
            sku: sku,
            code: code,
            properties: properties,
            maxWidth: maxWidth,
            image: customImage
        };

        $.get(Customizer.endpoint + 'rendercode', params, function(response) {
            svg = response.svg.replace('<?xml version="1.0" encoding="utf-8"?>', '');
            $product.find('.product-thumbnail__image img').hide();
            $product.find('.product-thumbnail-preview').html(svg).css('opacity', 1);

            // Add fonts needed for render.
            matches = svg.match(/font-family: [^;]*/);
            // matches = svg.match(/font-family: (\w+)/);
            if(matches[0]){
                let updatedMatch = matches[0].replace('font-family: ', '');
                updatedMatch = updatedMatch.replace(' ', '+');
                if(updatedMatch) {
                    var s = document.createElement("link");
                    s.href = "https://fonts.googleapis.com/css?family=" + updatedMatch;
                    s.rel = 'stylesheet';
                    $("head").append(s);
                }
            }
            
        }, 'json');
    });
}

/**
 * Track mouse movement so we can adjust the custom image
 * overlay.
 */
Customizer.move = function(e) {

    var $elem = $('#image-overlay');
    var elem = $('#image-overlay')[0];
    var $stage = $('.customizer-stage');

    if(Customizer.customImage.dragging) {


        var w = parseInt(elem.style.width);
        var h = parseInt(elem.style.height);

        var rad = Customizer.customImage.rotation * Math.PI / 180;

        var rx = e.clientX;
        var ry = e.clientY;
        // var rx = e.clientX*Math.cos(rad) + e.clientY*Math.sin(rad);
        // var ry = e.clientY*Math.cos(rad) - e.clientX*Math.sin(rad);

        // var rx = e.clientX*Math.cos(rad) - e.clientY*Math.sin(rad);
        // var ry = e.clientX*Math.sin(rad) + e.clientY*Math.cos(rad);


        var left = (rx - Customizer.customImage.offsetX);
        var top = (ry - Customizer.customImage.offsetY);

        
        // Keep div within bounds.
        // if(left + w > $stage.width()) left = $stage.width() - w;
        // if(top + h > $stage.height()) top = $stage.height() - h;
        // if(left < 0) left = 0;
        // if(top < 0) top = 0;
            
        // Move the div.
        elem.style.top = top + 'px';
        elem.style.left = left + 'px';

        // $('#custom-image-container div').css('width', elem.style.width);
        // $('#custom-image-container div').css('height', elem.style.height);

        Customizer.positionMask();
    }

    if(Customizer.customImage.resizing) {

        
        // Can resize outside the bounding box.
        // if(e.clientX > $stage.offset().left + $stage.width() || e.clientY > $stage.offset().top + $stage.height())
        //     return;

        elem.style.width = (e.clientX - $(elem).offset().left) + 'px';
        elem.style.height = ((e.clientX - $(elem).offset().left) / Customizer.customImage.aspectRatio) + 'px';

        // $('#custom-image-container div').css('width', elem.style.width);
        // $('#custom-image-container div').css('height', elem.style.height);

        Customizer.positionMask();
    }
};

/**
 * Position the see-through portion of the custom image mask
 * to overlay the appropriate spot on the design.
 */
Customizer.positionMask = function() {

    return;

    var $overlay = $('#image-overlay');
    var scale = $overlay.width() / Customizer.customImage.mappedWidth;
    
    var $stage = $('.customizer-stage');
    var $svg = $('.customizer-stage .svg-container svg');
    var offsetX = $svg.offset().left - $stage.offset().left - 10;
    var offsetY = $svg.offset().top - $stage.offset().top - 10;


    offsetX -= parseInt($overlay[0].style.left) - 10;
    offsetY -= parseInt($overlay[0].style.top) - 10;

    var $mask = $('#image-overlay svg rect.show');
    var rad = Customizer.customImage.rotation * Math.PI / 180;
    var x = (Customizer.customImage.mask.x + offsetX) / scale;
    var y = (Customizer.customImage.mask.y + offsetY) / scale;
    var rx = x*Math.cos(rad) + y*Math.sin(rad);
    var ry = y*Math.cos(rad) - x*Math.sin(rad);

    console.log(x +':'+rx+', ' + y + ':' + ry);
    $mask.attr('x', rx);
    $mask.attr('y', ry);
    $mask.attr('width', Customizer.customImage.mask.width / scale);
    $mask.attr('height', Customizer.customImage.mask.height / scale);
    $mask.attr('rx', Customizer.customImage.mask.radius * (Customizer.customImage.mask.width / scale) / 100);

    var left = 0 - (Customizer.customImage.mask.x + offsetX);
    var top = 0 - (Customizer.customImage.mask.y + offsetY);
    console.log(Customizer.customImage.mask.y);
    console.log(offsetY);
    console.log(left + 'px ' + top  + 'px');
    // $('#custom-image-container div').css('background-position', (Customizer.customImage.offsetX + left) + 'px ' + (Customizer.customImage.offsetX + top)  + 'px');
    $('#custom-image-container div').css('background-position', left + 'px ' + top  + 'px');
    var svgWidth = $('.svg-container > svg').width();
    var factor = 500 / svgWidth;
    var imageWidth = $('#custom-image-container div').width();
    Customizer.app.customImage.left = left * factor;
    Customizer.app.customImage.top = top * factor;
    Customizer.app.customImage.scale = imageWidth / Customizer.customImage.width * factor;
    Customizer.app.customImage.url = Customizer.customImage.url;
    Customizer.app.$forceUpdate();
    console.log($('#custom-image-container div').css('background-position'));

    console.log('zoom: ' + Customizer.customImage.zoom);
    $('#custom-image-container div').css('width', $overlay[0].style.width);
    $('#custom-image-container div').css('height', $overlay[0].style.height);
    return;

    var $overlay = $('.overlay');
    overlayLeft = parseInt($overlay.offset().left);
    overlayTop = parseInt($overlay.offset().top);
    var overlayWidth = $overlay.width();
    var overlayHeight = $overlay.height();

    var $canvas = $('.overlay');
    var canvasLeft = parseInt($canvas.offset().left);
    var canvasTop = parseInt($canvas.offset().top);
    var canvasWidth = $canvas.width();
    var canvasHeight = $canvas.height();


    // console.log(left);
    // console.log(circleLeft);
    // console.log(radius);

    // console.log(overlayLeft);
    // console.log(overlayLeft);
    // console.log(overlayWidth);
    // console.log(overlayHeight);

    var base = Math.sqrt(mappedWidth*mappedWidth + mappedHeight*mappedHeight);
    b100 = base / 1.414214;
    var diagonal = Math.sqrt(overlayWidth*overlayWidth + overlayHeight*overlayHeight);
    var d100 = diagonal / 1.414214;
    var df = d100/b100;
    var r = radius / df;
    
    var cy = circleTop + radius - overlayTop;
    cy *= mappedHeight / overlayHeight;

    var cx = circleLeft + radius - overlayLeft;
    cx *= mappedWidth / overlayWidth;

    // var rw = radius / overlayWidth * 100;
    // var rh = radius / overlayHeight * 100 / hf;

    // var r = rw > rh ? rw : rh;

    var $svg = $('svg');
    if(overlayHeight > overlayWidth) {
        $svg.attr('height', '100%');
        $svg.removeAttr('width');
    }
    else {
        $svg.attr('width', '100%');
        $svg.removeAttr('height');
    }

    // console.log(cx);
    $('#overlay svg mask circle').attr('cx', cx);
    $('#overlay svg mask circle').attr('cy', cy);
    $('#overlay svg mask circle').attr('r', r);
}

/**
 * Stop tracking mouse movement.
 */
Customizer.mouseUp = function() {

    console.log('mouse up');
    
    Customizer.customImage.dragging = false;
    Customizer.customImage.resizing = false;
}

/**
 * Initialize mouse tracking for modifying the custom
 * image overlay.
 */
Customizer.mouseDown = function(e) {

    return;
    console.log('mouse down');

    // if($(this).hasClass('handle')) {
    //     Customizer.customImage.resizing = true;
    // }
    // else {
    //     Customizer.customImage.dragging = true;
    // }

    var elem = $('#image-overlay')[0];

    var $overlay = $('#custom-image-container');
    var overlayLeft = parseInt($overlay.offset().left);
    var overlayTop = parseInt($overlay.offset().top);
    var overlayWidth = $overlay.width();
    var overlayHeight = $overlay.height();

    var $handle = $('.handle');
    var handleLeft = parseInt($handle.offset().left);
    var handleTop = parseInt($handle.offset().top);
    var handleWidth = $handle.width();
    var handleHeight = $handle.height();

    var overlayEndX = overlayWidth + overlayLeft;
    var overlayEndY = overlayHeight + overlayTop;

    var handleEndX = handleWidth + handleLeft;
    var handleEndY = handleHeight + handleTop;

    // if(e.clientX > handleLeft && e.clientX < handleEndX &&
    //     e.clientY > handleTop && e.clientY < handleEndY) {
    //     Customizer.customImage.resizing = true;
    //     return;
    // }

    console.log('x: ' + e.clientX + ',' + overlayLeft + ',' + overlayEndX);
    console.log('y: ' + e.clientY + ',' + overlayTop + ',' + overlayEndY);
    if(e.clientX > overlayLeft && e.clientX < overlayEndX &&
        e.clientY > overlayTop && e.clientY < overlayEndY) {

        Customizer.customImage.dragging = true;
        var left = 0;
        var top = 0;
        if(elem.style.left)
            left = parseInt(elem.style.left);
        if(elem.style.top)
            top = parseInt(elem.style.top);

        Customizer.customImage.offsetX = e.clientX - left;
        Customizer.customImage.offsetY = e.clientY - top;
    }

}

/**
 * Setup events and positioning for managing a custom image.
 */
Customizer.initCustomImage = function(pos) {

    Customizer.customImage.initialized = true;

//     $('.svg-container svg image').attr('xlink:href', Customizer.customImage.url);
    Customizer.app.customImage.url = Customizer.customImage.url;

    return;

    var $container = $('.customizer-stage');
    var width = $container.width();
    var height = $container.height();

    Customizer.customImage.aspectRatio = Customizer.customImage.width / Customizer.customImage.height;

    if(Customizer.customImage.width > Customizer.customImage.height) {
        Customizer.customImage.mappedWidth = width;
        Customizer.customImage.mappedHeight = width / Customizer.customImage.aspectRatio;
        Customizer.customImage.scale = Customizer.customImage.width / width;
    } 
    else {
        Customizer.customImage.mappedHeight = height;
        Customizer.customImage.mappedWidth = height / Customizer.customImage.aspectRatio;
    }

    console.log('mw ' + Customizer.customImage.mappedWidth);
    console.log('mh ' + Customizer.customImage.mappedHeight);

    return;

    $('#image-overlay').css('width', Customizer.customImage.mappedWidth + 'px');
    $('#image-overlay').css('height', Customizer.customImage.mappedHeight + 'px');
    $('#image-overlay').css('top', '10px');
    $('#image-overlay').css('left', '10px');
    
    var $svg = $('svg#custom-image');
    $svg[0].setAttribute('viewBox', '0 0 ' + Customizer.customImage.mappedWidth + ' ' + Customizer.customImage.mappedHeight);
    $('rect.base').attr('width', Customizer.customImage.mappedWidth)
        .attr('height', Customizer.customImage.mappedHeight);


    // Get offset to the start of the svg render.
    var $stage = $('.customizer-stage');
    var $svg = $('.customizer-stage .svg-container svg');
    Customizer.customImage.offsetX = $svg.offset().left - $stage.offset().left - 10;
    Customizer.customImage.offsetY = $svg.offset().top - $stage.offset().top - 10;

    // var $parentSvg = $('.customizer-stage > svg');
    // offsetX + $parentSvg.offset().left;
    // offsetY + $parentSvg.offset().top;

    Customizer.customImage.mask.x = pos.x;
    Customizer.customImage.mask.y = pos.y;
    Customizer.customImage.mask.width = pos.width;
    Customizer.customImage.mask.height = pos.height;
    Customizer.customImage.mask.radius = pos.radius;

    var $overlay = $('#image-overlay');
    var $mask = $('#image-overlay svg rect.show');
    $mask.attr('x', pos.x + Customizer.customImage.offsetX);
    $mask.attr('y', pos.y + Customizer.customImage.offsetY);
    $mask.attr('width', pos.width);
    $mask.attr('height', pos.height);
    $mask.attr('rx', pos.radius);

    var $chosen = $('#custom-image-container');
    $chosen.css('left', (pos.x + Customizer.customImage.offsetX + 10) + 'px');
    $chosen.css('top', (pos.y + Customizer.customImage.offsetY + 10) + 'px');
    $chosen.css('width', pos.width + 'px');
    $chosen.css('height', pos.height + 'px');
    $chosen.css('border-radius', pos.radius + "%");

    // var scale = Customizer.customImage.mappedWidth
}

Customizer.authWindow = false;

Customizer.loadInstagramImages = function() {

    console.log('loadInstagramImages');
    Customizer.app.imageSource = 'instagram';
    Customizer.app.images = [];
        $.get('https://graph.instagram.com/me/media?fields=id,media_type,media_url&access_token=' + Customizer.token, function(response) {
            for(var i = 0; i < response.data.length; i++) {
                var media = response.data[i];
                if(media.media_type == 'IMAGE')
                    Customizer.app.images.push(media.media_url)
            }

            Customizer.app.nextImagesUrl = response.paging.next;

        }).fail(function(response) {

            // If the request failed then we probably need a new token.
            if(response.status == 400) {

            }
        });
}

$('body').on('click', '#instagram-images', function() {

    $('.tab.active').removeClass('active');
    $(this).addClass('active');
    var token = Cookies.get('instagramToken');
    Customizer.app.images = [];
    Customizer.app.imageSource = 'instagram';
    if(!token) {
        Customizer.app.instagramConnected = false;

    }
    else {
        Customizer.app.instagramConnected = true;
        Customizer.token = token;
        Customizer.loadInstagramImages();
    }
});

$('body').on('click', '#instagram-auth', function() {
    Customizer.authWindow = window.open('https://api.instagram.com/oauth/authorize' +
        '?client_id=941224219661545' +
        '&redirect_uri=https://name-bubbles.app/instagram/oauth' +
        '&scope=user_profile,user_media' +
        '&response_type=code',
        '_blank', 'width=500,height=500');
});

Customizer.loadFacebookPhotos = function() {
    Customizer.app.images = [];
    Customizer.app.imageSource = 'facebook';
    FB.api(
        '/me/photos?type=uploaded',
        'GET',
        {"fields":"height,width,images"},
        function(response) {
    
            for(var i = 0; i < response.data.length; i++) {
                var media = response.data[i];
                if(media.images[3] != undefined)
                    Customizer.app.images.push(media.images[3].source);
            }
            
            if(response.paging)
                Customizer.app.nextImagesUrl = response.paging.next;
            else 
                Customizer.app.nextImagesUrl = '';
        }
    );
};

$('body').on('click', '#facebook-images', function() {
    $('.tab.active').removeClass('active');
    $(this).addClass('active');
    FB.getLoginStatus(function(response) {
        console.log(response);
        Customizer.app.imageSource = 'facebook';
        if(response.status != 'connected') {
            Customizer.app.facebookConnected = false;
            
        }
        else {
            Customizer.app.facebookConnected = true;
            Customizer.loadFacebookPhotos();
        }
    });
});

$('body').on('click', '#facebook-auth', function(e) {
    e.preventDefault();
    console.log('facebook auth clicked');
    FB.login(function(response) {
        Customizer.app.facebookConnected = true;
        Customizer.loadFacebookPhotos();
    }, {scope: 'user_photos'});
});

$('body').on('click', '#show-recent', function() {
    $('.tab.active').removeClass('active');
    $(this).addClass('active');
    Customizer.app.imageSource = 'recent';
    Customizer.app.nextImagesUrl = '';
});

window.addEventListener("message", receiveMessage, false);

function receiveMessage(event) {

    if(event.data.token) {
        Cookies.set('instagramToken', event.data.token, { expires: 1/24 });
        Customizer.token = event.data.token;
        Customizer.app.instagramConnected = true;
        Customizer.loadInstagramImages();
        console.log('received event');
        console.log(event);
    }
}




init_selling_plan_handling()

//keep checking until RC loads, after that hook up all events
function init_selling_plan_handling(){
  if(document.querySelector('form.product-form')){
    const rcContainer = document.querySelector('.rc-container-wrapper')
    if(!rcContainer){
      console.log('%c Check for rc inputs...', 'background: #222; color: #bada55')
      setTimeout(init_selling_plan_handling, 500)
    } else {
      handle_selling_plan_updated()
      const inputs = rcContainer.querySelectorAll('input, select')
      inputs.forEach(input => input.addEventListener('change', e => handle_selling_plan_updated()))

      //move it above the purchase container
      document.querySelector('form.product-form').insertBefore(rcContainer, document.querySelector('form.product-form .purchase'))

      //now we can run the init
      Customizer.init($('#customizer').data('design'));      
    }
  }
}

function getUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string'){
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

function handle_selling_plan_updated(){
  console.log('%c Selling plan ready', 'background: #222; color: #bada55')

  const params = getUrlParams()
  if(params?.selling_plan){
    const option = document.querySelector(`option[value="${params.selling_plan}"]`)
    if(option){
      option.parentNode.value = params.selling_plan
      option.closest('.rc-radio').querySelector('input[type="radio"]').click()
      console.log('%c Autoclick subscription', 'background: #222; color: #bada55')
    }
  }

  setTimeout(() => {
    const selected = document.querySelector('.rc-container-wrapper input:checked')
    if(selected){
      const newPrice = selected.closest('.rc-radio').querySelector('.rc-option__price').innerText.replace("$", "")
      //no idea which of these this app uses at any given point... so just take the nuclear approach and change everything
      document.querySelector("#customizer").setAttribute('data-variant-price', newPrice)
      document.querySelector(".price__is").innerText = `$${newPrice}`
      Customizer.app.variant.price = parseFloat(newPrice)
      Customizer.app.variants.forEach(v => v.price = parseFloat(newPrice))
      console.log(`%c Updating new price: ${Customizer.app.variant.price}`, 'background: #222; color: #bada55')
    }
  })
}